module.exports = __webpack_public_path__ + "media/svg/account-multiple-outline-2354aab5.svg";